import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Briefcase, CreditCard, LogOut, Radar } from "lucide-react";

const NAV = [
  { to: "/partner", label: "Job Postings", icon: Briefcase, end: true },
  { to: "/partner/billing", label: "Billing", icon: CreditCard },
];

export default function PartnerLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen flex bg-[#0B0B0F] text-white">
      <aside className="w-60 shrink-0 border-r border-white/10 flex flex-col fixed h-screen bg-[#0B0B0F] z-20">
        <Link to="/" className="h-16 flex items-center gap-2 px-5 border-b border-white/10">
          <div className="h-7 w-7 bg-[#F5A623] flex items-center justify-center">
            <Radar className="h-4 w-4 text-[#0B0B0F]" strokeWidth={2} />
          </div>
          <div className="leading-tight">
            <p className="font-heading font-black text-sm tracking-tight text-white">INNOVATION</p>
            <p className="text-[0.55rem] leading-none tracking-[0.2em] text-[#F5A623] uppercase">Recruiting Partner</p>
          </div>
        </Link>
        <nav className="flex-1 py-4 flex flex-col gap-0.5 px-3">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end}
              data-testid={`pnav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors duration-150 ${
                  isActive ? "bg-[#F5A623] text-[#0B0B0F]" : "text-white/60 hover:text-white hover:bg-white/5"
                }`}>
              <item.icon className="h-4 w-4" strokeWidth={1.5} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 p-3">
          <div className="px-2 py-2 mb-1">
            <p className="text-sm font-medium truncate">{user?.full_name}</p>
            <p className="text-[0.55rem] uppercase tracking-[0.2em] text-white/40">Recruiting Partner</p>
          </div>
          <button onClick={handleLogout} data-testid="logout-btn"
            className="flex items-center gap-3 px-3 py-2.5 text-sm w-full text-white/60 hover:text-white hover:bg-white/5 transition-colors duration-150">
            <LogOut className="h-4 w-4" strokeWidth={1.5} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-h-screen bg-background text-foreground"><Outlet /></main>
    </div>
  );
}
